/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import divorcePlannerStyle from "./divorcePlannerStyle";
import Paper from "@mui/material/Paper";
import processInDetailImage from "@/src/assets/img/planner/icon_process_details_150px.png";
import checklistImage from "@/src/assets/img/planner/icon_checklist_150px.png";
import childrenImage from "@/src/assets/img/planner/icon_child_150px.png";
import pcsImage from "@/src/assets/img/planner/icon_vkh_150px.png";
import downloadImage from "@/src/assets/img/planner/icon_download_150px.png";
import { STATUS_CHECKED } from "@/src/services/divorce/leadStatus";
import DivorcePlannerModal from "./Modal/DivorcePlannerModal";
import { API_HOST, API_PATH } from "@/src/config/_entrypoint";
import { getCaseLink } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import { Link } from "react-router";

type DivorcePlannerNavigationProps = {
  divorce: AbstractCase;
  accessible: boolean;
};
const DivorcePlannerNavigation = ({ divorce, accessible }: DivorcePlannerNavigationProps) => {
  const [open, setOpen] = useState(false);

  const triggerModal = (event: { preventDefault: () => void }) => {
    if (accessible) {
      return;
    }
    setOpen(true);
    event.preventDefault();
  };

  const downloadLink = API_HOST + API_PATH + "/download/scheidungsplaner/" + divorce.id + "?token=" + localStorage.getItem("token");
  return (
    <>
      <Grid container spacing={3} sx={{
        justifyContent: "center"
      }}>
        <Grid size={12}>
          <Paper sx={divorcePlannerStyle.navigationPaper} component={Link} onClick={triggerModal} to="#ablauf" elevation={4}>
            <Grid container sx={divorcePlannerStyle.headlineContent}>
              <Grid size="auto">
                <Box>
                  <Paper sx={divorcePlannerStyle.imageCircle}>
                    <img src={processInDetailImage} alt={"Ablauf"} />
                  </Paper>
                </Box>
              </Grid>
              <Grid size="grow">
                <Box sx={divorcePlannerStyle.contentName}>Ablauf im Detail</Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper sx={divorcePlannerStyle.navigationPaper} component={Link} onClick={triggerModal} to="#checkliste" elevation={4}>
            <Grid container sx={divorcePlannerStyle.headlineContent}>
              <Grid size="auto">
                <Box>
                  <Paper sx={divorcePlannerStyle.imageCircle}>
                    <img src={checklistImage} alt={"Checkliste"} />
                  </Paper>
                </Box>
              </Grid>
              <Grid size="grow">
                <Box sx={divorcePlannerStyle.contentName}>Meine Checklisten</Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {divorce.hasProcessCostSupport && divorce.leadStatus < STATUS_CHECKED && (
          <Grid size={12}>
            <Paper sx={divorcePlannerStyle.navigationPaper} component={Link} onClick={triggerModal} to={getCaseLink(divorce) + "/vkh-assistent"} elevation={4}>
              <Grid container sx={divorcePlannerStyle.headlineContent}>
                <Grid size="auto">
                  <Box>
                    <Paper sx={divorcePlannerStyle.imageCircle}>
                      <img src={pcsImage} alt={"VKH"} />
                    </Paper>
                  </Box>
                </Grid>
                <Grid size="grow">
                  <Box sx={divorcePlannerStyle.contentName}>Verfahrenskostenhilfe beantragen</Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        {divorce.numberChildren !== 0 && (
          <Grid size={12}>
            <Paper sx={divorcePlannerStyle.navigationPaper} component={Link} onClick={triggerModal} to="#kinder" elevation={4}>
              <Grid container sx={divorcePlannerStyle.headlineContent}>
                <Grid size="auto">
                  <Box>
                    <Paper sx={divorcePlannerStyle.imageCircle}>
                      <img src={childrenImage} alt={"Kinder"} />
                    </Paper>
                  </Box>
                </Grid>
                <Grid size="grow">
                  <Box sx={divorcePlannerStyle.contentName}>Trennung mit Kindern</Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        <Grid size={12}>
          <Paper sx={divorcePlannerStyle.navigationPaper} component={"a"} onClick={triggerModal} href={downloadLink} elevation={4}>
            <Grid container sx={divorcePlannerStyle.headlineContent}>
              <Grid size="auto">
                <Box>
                  <Paper sx={divorcePlannerStyle.imageCircle}>
                    <img src={downloadImage} alt={"download"} />
                  </Paper>
                </Box>
              </Grid>
              <Grid size="grow">
                <Box sx={divorcePlannerStyle.contentName}>Scheidungsplaner herunterladen</Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <DivorcePlannerModal open={open} onClose={() => setOpen(false)} divorce={divorce} />
    </>
  );
};

export default DivorcePlannerNavigation;
